import React, { Fragment, useEffect, useState } from 'react';

import { useHistory, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import ConditionalCard from 'Components/Reusable/Cards/ConditionalCard';
import { generateNewToy } from 'ReduxStore/toys/Action';
import { Routes } from 'Utils';
import generateNewToyImage from 'Assets/img/svg/gen.svg';
interface RouteParams {
	id: string;
}
const GenerateNewToy = (props: any) => {
	const dispatch = useDispatch();
	const [loading, setLoading] = useState<boolean>(false);
	const history = useHistory();
	const childName = localStorage.getItem('currentChild');

	const conditions = [{ id: 1, name: `Return to Activities` }];
	const handleGenerateNewToy = () => {
		setLoading(true);
		// generateNewToy()(dispatch)
		return history.push(Routes.Process);
	};
	return (
		<Fragment>
			<ConditionalCard
				image={generateNewToyImage}
				information={`${childName}'s new Toolbox will be shipped shortly. Instructions for the new toy will be updated once the toolbox is received.`}
				conditions={conditions}
				onClick={handleGenerateNewToy}
				common={{ background: '#d4d4d4' }}
			/>
		</Fragment>
	);
};

export default GenerateNewToy;
